import styled from 'styled-components';

export const Jumbotron = styled.div`
  background: ${props => props.theme.gray700};
  color: white;
  position: relative;
  background: url(${props => props.heroImage ? props.heroImage : '/static/clientbooks-hero-mobile.jpg'}) no-repeat center;
  background-size: cover;
  background-position-y: top;
  ${props => props.theme.media.md} {
    background-image: url(${props => props.heroImage ? props.heroImage : '/static/clientbooks-home-hero.jpg'});
    background-attachment: ${props => (props.Fixed ? 'fixed' : 'initial')};
  }
  .overlay {
    background: rgba(44, 50, 59, 0.7);
  }
`;


export const Hero = styled.div`
  color: white;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  ${props => props.theme.media.sm} {
    display: flex;
    flex-direction: column;
  }
  ${props => props.theme.media.md} {
    min-height: ${props => (props.Short ? '419px' : 'auto')};
  }
  ${props => props.theme.media.lg} {
    padding: 60px 0;
  }
  h1 {
    margin-bottom: ${props => props.Short && '10px'};
  }
  .job-title {
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 3em;
  }
  ${props => props.theme.media.md} {
    min-height: ${props => (props.Short ? '419px' : 'calc(50vh)')};
  }
  p {
    color: white;
    font-size: 0.9375rem;
    font-weight: 300;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    ${props => props.theme.media.sm} {
      font-size: 1.375rem;
    }
    &.full-width {
      max-width: 100%;
    }
  }
  .btn {
    margin-top: 15px;
  }
`;